import { Icon } from '../design/Icon';
import { useTheme } from '../design/theme';

/** Bascule clair / sombre (maquette 2a) : lune en thème clair, soleil en thème sombre. */
export function ThemeToggle({ size = 44 }: { size?: number }) {
  const [theme, setTheme] = useTheme();
  return (
    <button
      type="button"
      className="sh-iconbtn"
      style={{ width: size, height: size }}
      aria-label="Basculer clair / sombre"
      title="Basculer clair / sombre"
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    >
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={size >= 48 ? 22 : 20} />
    </button>
  );
}
